import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import {
  ACCESS_CODE,
  ACTIVITY_LOG,
  COMMON_TRANSLATION,
  HOME,
  LOGIN_TRANSLATION,
  PROMOTION,
  TOUR_TRASH_TRANSLATION,
  TRY_THEN_BUY,
  TRY_THEN_BUY_FRAUD,
  GRAPHICS,
  MISC,
  PRODUCT,
  BENEFIT,
  PARTNER,
  LAUNCH_FEATURES,
  USER_PROFILE,
  LOYALTY_ACTION,
  PRODUCT_TILE,
  MORE_FOR_YOU,
  MAINSTAYS,
  THE_DAILY,
  HOME_PRODUCT,
  PLAYER_COACH,
  JUST_IN_CLUBHOUSE,
  TOUR_STORIES,
  CARTNER_CONVOS,
  SHOP_CATEGORIES,
  GAME_PROFILE,
} from '../constants/define/translation';
import common from './en';
import tourTrash from './en/tourTrash';
import login from './en/login';
import activityLog from './en/activityLog';
import home from './en/home';
import promotion from './en/promotion';
import accessCode from './en/accessCode';
import tryThenBuy from './en/tryThenBuy';
import tryThenBuyFraud from './en/tryThenBuyFraud';
import graphics from './en/graphics';
import misc from './en/misc';
import product from './en/product';
import benefit from './en/benefit';
import partner from './en/partner';
import launchFeatures from './en/launchFeatures';
import userProfile from './en/userProfile';
import loyaltyAction from './en/loyaltyAction';
import productTile from './en/productTile';
import moreForYou from './en/moreForYou';
import mainstays from './en/mainstays';
import theDaily from './en/theDaily';
import homeProduct from './en/homeProduct';
import playerCoach from './en/playerCoach';
import justInClubhouse from './en/justInClubhouse';
import tourStories from './en/tourStories';
import cartnerConvos from './en/cartnerConvos';
import shopCategories from './en/shopCategories';
import gameProfile from './en/gameProfile';

// the translations
export const defaultNS = COMMON_TRANSLATION;
export const ns = [
  COMMON_TRANSLATION,
  TOUR_TRASH_TRANSLATION,
  LOGIN_TRANSLATION,
  ACTIVITY_LOG,
  HOME,
  PROMOTION,
  ACCESS_CODE,
  TRY_THEN_BUY,
  TRY_THEN_BUY_FRAUD,
  GRAPHICS,
  MISC,
  PRODUCT,
  BENEFIT,
  PARTNER,
  LAUNCH_FEATURES,
  USER_PROFILE,
  LOYALTY_ACTION,
  PRODUCT_TILE,
  MORE_FOR_YOU,
  MAINSTAYS,
  THE_DAILY,
  HOME_PRODUCT,
  PLAYER_COACH,
  JUST_IN_CLUBHOUSE,
  TOUR_STORIES,
  CARTNER_CONVOS,
  SHOP_CATEGORIES,
  GAME_PROFILE,
];
export const resources = {
  en: {
    common,
    tourTrash,
    login,
    activityLog,
    home,
    promotion,
    accessCode,
    tryThenBuy,
    tryThenBuyFraud,
    graphics,
    misc,
    product,
    benefit,
    partner,
    launchFeatures,
    userProfile,
    loyaltyAction,
    productTile,
    moreForYou,
    mainstays,
    theDaily,
    homeProduct,
    playerCoach,
    justInClubhouse,
    tourStories,
    cartnerConvos,
    shopCategories,
    gameProfile,
  },
} as const;

i18n.use(initReactI18next).use(LanguageDetector).init({
  fallbackLng: 'en',
  ns,
  defaultNS,
  resources,
});
